import { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

interface UseGeneralHook {
  open: boolean;
  osId: number;
  navigateHome(): void;
  handleOpen(): void;
  handleClose(): void;
  checkPathname(value: string): boolean;
  handleDownloadFile: (
    value: string,
    name: string,
    blankPage?: boolean
  ) => void;
  handleDownloadPdf: (value: File) => void;
  handleDownloadXlsx: (value: Response) => void;
}

export default function useGeneral(): UseGeneralHook {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const osId = parseInt(id as string, 10);
  const [open, setOpen] = useState(false);

  const navigateHome = (): void => {
    navigate('/home');
  };
  const handleOpen = (): void => setOpen(true);
  const handleClose = (): void => setOpen(false);
  const checkPathname = (value: string): boolean => {
    return location.pathname.includes(value);
  };

  const handleDownloadFile = (
    dataLink: string,
    name: string,
    blankPage?: boolean
  ): void => {
    const linkSource = dataLink;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = name;
    if (blankPage) {
      window.open(linkSource);
    } else {
      downloadLink.click();
    }
  };

  const handleDownloadPdf = (pdf: File): void => {
    if (!pdf.name) return;
    const temp = document.createElement('a');
    document.body.appendChild(temp);

    const url = window.URL.createObjectURL(pdf);
    temp.href = url;
    temp.download = pdf.name;
    temp.click();
    window.URL.revokeObjectURL(url);
  };

  const handleDownloadXlsx = (data: Response): void => {
    const contentDisposition = data.headers
      .get('Content-Disposition')
      ?.split('filename=')[1];
    const filename = contentDisposition || 'file.xlsx';
    data.blob().then((blob) => {
      const url = window.URL.createObjectURL(blob);
      handleDownloadFile(url, filename);
      window.URL.revokeObjectURL(url);
    });
  };

  return {
    open,
    osId,
    navigateHome,
    checkPathname,
    handleOpen,
    handleClose,
    handleDownloadFile,
    handleDownloadPdf,
    handleDownloadXlsx,
  };
}
